import React , { useEffect, useState }from 'react'
import './descarga.css'
import NLV_descarga_libro from '../../../assets/imgs/nuevo_libro/NL_descargar_libro.png'
import NLV_descarga_line from '../../../assets/imgs/libro_verde/NLV_linea.png'
import { useTranslation } from "react-i18next";

const Desecarga = () => {
    const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("librVerd");

    return (
    <div class="NLV_descarga">
        <div class="NLV_descarga_laptop">
            <div class="NLV_descarga_img">
                <img src={NLV_descarga_libro}/>
            </div>
            <div class="NLV_descarga_content">
                <div class="NLV_descarga_txt">
                    <h2>
                        {(t('descarga.parrafo1'))}<span>{(t('descarga.span1'))}</span><br/>
                    </h2>    
                    <p>
                    {(t('descarga.parrafo2'))}<span>{(t('descarga.span2'))}</span>{(t('descarga.parrafo3'))}
                    </p>
                </div>
                <div class="NLV_descarga_line ">
                    <img src={NLV_descarga_line}/>
                </div>
                <div class="NLV_descarga_button">
                    <a href="https://www.ricardosalinas.com/Content/assets/documents/fragmento-libro-sociedades.pdf" target="_blank" download="fragmento-libro-sociedades.pdf" rel="noreferrer">
                    <button>{(t('descarga.button'))}</button>
                    </a>
                </div>
            </div>
        </div>
        <div class="NLV_descarga_movil">
            <div class="NLV_descarga_img">
                <img src={NLV_descarga_libro}/>
            </div>
            <div class="NLV_descarga_txt1">
                <p>
                      
                </p>
            </div>
            <div class="NLV_descarga_txt1 movil_solo">
                <p>
                    
                </p>
            </div>
            <div class="NLV_descarga_line">
                <img src={NLV_descarga_line}/>
            </div>
            <div class="NLV_descarga_txt2">
                <p>
                </p>
            </div>
            <div class="NLV_descarga_button">
                <button></button>
            </div>
        </div>
    </div>
  )
}

export default Desecarga
